import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "wpa-web",
  "use": "wpa-web-usage",
  "viewBox": "0 0 18 16",
  "content": "<symbol viewBox=\"0 0 18 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"wpa-web\">\r\n  <path d=\"M1 0h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm1 2v12h14V2H2zm0 1h14v2H2V3zm2 4h5v2H4V7zm0 3h10v2H4v-2z\" fill=\"#A8ABB3\" fill-rule=\"nonzero\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol